module.exports = __webpack_public_path__ + "img/RDA_tipoE_3pax_40m2.cc2a9126.png";